import { Box, BoxProps, SxProps } from "@mui/material";
import React, { FunctionComponent } from "react";



interface Props extends BoxProps {
	width?: any
	marginTop?: number

	renderLeft?: React.ReactNode
	renderRight?: React.ReactNode
	children?: React.ReactNode

	sx?: SxProps
	centerSx?: SxProps
	leftSx?: SxProps
	rightSx?: SxProps
}

const VerticalPage: FunctionComponent<Props> = ({
	width = "970px",
	marginTop = 0,

	renderLeft,
	renderRight,
	children,

	sx,
	centerSx,
	leftSx,
	rightSx,

	...props
}) => {

	const mt = `${marginTop}px`
	return (
		<Box sx={{ ...sxContainer as any, ...sx }} {...props}>

			{/* LEFT */}
			<Box sx={[sxLeft as any, { mt }, leftSx,]}>
				{renderLeft && (
					<Box sx={sxStiky(marginTop)}>
						{renderLeft}
					</Box>
				)}
			</Box>

			{/* CENTER */}
			<Box sx={{ ...sxCenter, maxWidth: width, mt, ...centerSx } as SxProps}>
				{children}
			</Box>

			{/* RIGHT */}
			<Box sx={[sxRight as any, { mt }, rightSx]} >
				{renderRight && (
					<Box sx={sxStiky(marginTop)}>
						{renderRight}
					</Box>
				)}
			</Box>

		</Box>
	)
}


export default VerticalPage


const sxContainer: SxProps = {
	display: "flex",
	justifyContent: "space-between",
	width: "100%"
}
const sxLeft: SxProps = {
	display: "flex",
	flexDirection: "column",
	flex: "0 1",
	p: "0px 0px 0px 16px",
}
const sxCenter: SxProps = {
	display: "flex",
	flexDirection: "column",
	flex: `1 0`,
	pt: "0px",
}
const sxRight: SxProps = {
	display: "flex",
	flexDirection: "column",
	flex: "0 1",
	p: "0px 0px 0px 16px",
}
const sxStiky = (mt: number): SxProps => ({
	position: "sticky",
	top: `${mt}px`,
})